import React, { ReactNode, useState } from 'react';
import { isMobile } from 'react-device-detect';

import { useOutsideClick } from 'shared/hooks/useOutsideClick';
import { Box } from 'shared/ui/Box';
import { Tooltip } from 'shared/ui/Popover/styled';

type Props = {
  children: ReactNode;
  text: string | ReactNode;
  bottom?: string;
  left?: string;
  whiteSpace?: string;
  isRender?: boolean;
  alwaysVisible?: boolean;
};

export const Popover: React.FC<Props> = ({ children, text, bottom, left, whiteSpace, isRender = true, alwaysVisible }) => {
  const [isVisible, setIsVisible] = useState(false);

  const { refElement } = useOutsideClick<HTMLDivElement>(() => setIsVisible(false));

  const toggleClick = () => {
    setIsVisible((prevIsVisible) => !prevIsVisible);
  };

  const isShowPopover = alwaysVisible || isVisible;

  if (!isRender) return <>{children}</>;

  return (
    <Box
      onMouseEnter={isMobile ? () => null : () => setIsVisible(true)}
      onMouseLeave={isMobile ? () => null : () => setIsVisible(false)}
      onClick={isMobile ? () => toggleClick() : () => null}
      ref={refElement}
      position='relative'
      maxWidth='100%'
      height='100%'
    >
      {children}
      {isShowPopover && (
        <Tooltip bottom={bottom} left={left} whiteSpace={whiteSpace}>
          {text}
        </Tooltip>
      )}
    </Box>
  );
};
